var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":""}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('div',[_vm._v("Copyright © 2019 Kaliss Japan. All rights reserved.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }